import React, { useContext, useState } from 'react';
import './signup.css';
import axios from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { API_URL } from '../../config/config';
import { AuthContext } from '../../auth/AuthContext';

const SignUp: React.FC = () => {
  const { login } = useContext(AuthContext);
  const [fullName, setFullName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user } = useAuth();

  const validateEmail = async (email: string) => {
    const splitted = email.split('@');
    if (splitted.length >= 2 && splitted[0] !== '') {
      return true;
    }
    return false;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (password !== confirmPassword) {
        setError('Passwords do not match.');
        return;
      }

      const validE = await validateEmail(email);
      if (!validE) {
        setError('Invalid Email!');
        return;
      }

      if (type === 'ADMIN') {
        const res = await axios.post(`${API_URL}/admin/`, {
          name: fullName,
          surname: surname,
          email,
          passwordHash: password,
        });
        localStorage.setItem('token', res.data.token);
      } else {
        if (user != null) {
          if (type === 'MANAGER') {
            const res = await axios.post(`${API_URL}/manager/${user.id}`, {
              name: fullName,
              surname: surname,
              email,
              passwordHash: password,
              type: type,
            });

            localStorage.setItem('token', res.data.token);
          } else if (type === 'EMPLOYEE') {
            const res = await axios.post(`${API_URL}/employee/${user.id}`, {
              name: fullName,
              surname: surname,
              email,
              passwordHash: password,
              type: type,
            });
            login(res.data.user, res.data.token);

            navigate('/');
            setError('');
          }
        }
      }
      navigate('/');
      setError('');
    } catch (err: any) {
      alert(err.response?.data?.error || 'Something went wrong');
    }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        <h2>Sign Up</h2>

        {error && <p className="error-message">{error}</p>}

        <div className="input-group">
          <label>First Name</label>
          <input
            type="text"
            placeholder="Enter your full name"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label>Surname</label>
          <input
            type="text"
            placeholder="Enter your full name"
            value={surname}
            onChange={e => setSurname(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label>Type</label>
          <select
            className="styled-select"
            value={type}
            onChange={e => setType(e.target.value)}
            required
          >
            <option value="">Select a role</option>
            <option value="ADMIN">ADMIN</option>
            <option value="EMPLOYEE">EMPLOYEE</option>
            <option value="MANAGER">MANAGER</option>
          </select>
        </div>

        <div className="input-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label>Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="signup-btn">
          Sign Up
        </button>

        <p className="login-link">
          Already have an account? <a href="/login">Log in</a>
        </p>
      </form>
    </div>
  );
};

export default SignUp;
